module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Mayans-S1.11ee763.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Mayans-S1.jpg
// module id = qKIS
// module chunks = 0